import { Education, Hours, Location, Locations, SalaryRange, SalaryValue } from '..';

export enum ChipUSPsVariant {
  Group = 'GROUP',
  LocationSpecific = 'LOCATION_SPECIFIC'
}

export type BaseChipUSPs = {
  variant: ChipUSPsVariant;
  hours?: Hours;
  salaryValue?: SalaryValue;
  salaryRange?: SalaryRange;
  relocationPossible: boolean;
  educationLevels: Education[];
  isCoolblueEnergy: boolean;
};

export type LocationSpecificChipUSPs = BaseChipUSPs & {
  variant: ChipUSPsVariant.LocationSpecific;
  location: Location;
};

export type GroupChipUSPs = BaseChipUSPs & {
  variant: ChipUSPsVariant.Group;
  locations: Locations;
};

export type ChipUSPs = LocationSpecificChipUSPs | GroupChipUSPs;
